import AboutBanner from './AboutBanner';
import AboutMeetSection from './AboutMeetSection';
import AboutCoreValue from './AboutCoreValue';


function About() {
  return (
    <div className='about-section-main-box'>
      <AboutBanner />
       <AboutMeetSection />
       <AboutCoreValue />
    </div>
  );
}

export default About;